import PayrollCard from './PayrollCard';

export default PayrollCard;
